import { useContext, useEffect, useState } from 'react';
import { TestingHqContext } from '../../context/TestingHqContext';
import { TestingContext } from '../../context/TestingContext';
import { get_testing_place_list, get_testing_type, get_testing_list, upsert_testing_place } from '../../utils/restapi';
import './joins.css';
import ListBody from '../../components/list/ListBody';

const TestingTeacherSetup = () => {
  const { testingHqs } = useContext(TestingHqContext);
  const { testingObj, setTestingObj } = useContext(TestingContext);

  // 선택상자 목록들
  const [testingTypes, setTestingTypes] = useState([]);
  const [testings, setTestings] = useState([]);

  // 목록
  const [items, setItems] = useState([]);
  const [originalItems, setOriginalItems] = useState([]); // 원본 데이터 저장
  const [changedItems, setChangedItems] = useState(new Set()); // 변경된 항목 인덱스 추적
  
  // 정렬 관련 상태
  const [sort, setSort] = useState('');
  const [desc, setDesc] = useState('');

  // 시험유형 데이터 가져오기
  const getTestingTypes = async () => {
    console.log('getTestingTypes called');
    try {
      const response = await get_testing_type();
      console.log("getTestingTypes:", response);
      setTestingTypes(response);
    } catch (error) {
      console.error("Error fetching types:", error);
    }
  };

  // 시험에 대한 데이터 가져오기
  const getTestings = async (type) => {
    console.log(`getTestings called : ${type}`);
    try {
      const response = await get_testing_list({ type, page:1, rowsPerPage:1000, sort:'a_testing_id', desc:'desc' });
      console.log("getTestings:", response);
      setTestings(response.lists || response);
    } catch (error) {
      console.error("Error fetching testing:", error);
      setTestings([]);
    }
  };

  // 고사장에 대한 데이터 가져오기
  const getTestingPlaces = async () => {
    console.log(`getTestingPlaces called : `, testingObj);
    console.log(`testingHqs : `, testingHqs);

    const json = {
      testing_id: testingObj?.testing_id || 0, // 수정: ?. 사용
      gcodes: testingHqs.map(hq => hq.code).join(','),
      page: 1,
      rowsPerPage: 1000,
      sort: 'b_gcode,b_code',
      desc: 'asc',
    };

    console.log("getTestingPlaces params:", json);

    if (json.testing_id === 0) {
      setItems([]);
      return;
    }

    try {
      const response = await get_testing_place_list(json);
      console.log("getTestingPlaces:", response);
      setItems(response.lists);
      setOriginalItems(JSON.parse(JSON.stringify(response.lists))); // 깊은 복사로 원본 저장
      setChangedItems(new Set()); // 변경 상태 초기화
      setSort(json.sort);
      setDesc(json.desc);
    } catch (error) {
      console.error("Error fetching testing_places:", error);
      setItems([]);
      setSort(json.sort);
      setDesc(json.desc);
    }
  };


  // 시험유형 선택 핸들러
  const handleTestingTypeChange = (e) => {
    console.log('handleTestingTypeChange called');
    const selectedValue = e.target.value;
    setTestingObj({ type: selectedValue });
  };

  // 시험 선택 핸들러
  const handleTestingChange = (e) => {
    console.log('handleTestingChange called');
    const selectedValue = e.target.value;
    const selectedTesting = testings.find(obj => obj.testing_id === parseInt(selectedValue));
    setTestingObj(selectedTesting);
  };

  // 고사장 정보 업데이트
  const handleSubmit = async () => {
    console.log('handleSubmit called');
    console.log('변경된 항목들:', Array.from(changedItems));
    
    if (changedItems.size === 0) {
      alert('변경된 항목이 없습니다.');
      return;
    }

    const updatePromises = [];
    
    // 변경된 항목들만 순회
    for (const index of changedItems) {
      const item = items[index];
      
      // API 호출을 위한 데이터 구성
      const updateData = {
        testing_place_id: item.testing_place_id,
        data: item.data // JSON 형태로 전체 data 전송
      };
      
      console.log(`인덱스 ${index} 업데이트:`, updateData);
      
      // Promise 배열에 추가
      updatePromises.push(
        upsert_testing_place(updateData)
          .then(result => {
            console.log(`인덱스 ${index} 업데이트 성공:`, result);
            return { index, success: true, result };
          })
          .catch(error => {
            console.error(`인덱스 ${index} 업데이트 실패:`, error);
            return { index, success: false, error };
          })
      );
    }

    try {
      // 모든 업데이트를 병렬로 실행
      const results = await Promise.all(updatePromises);
      
      // 결과 확인
      const successCount = results.filter(r => r.success).length;
      const failCount = results.filter(r => !r.success).length;
      
      if (failCount === 0) {
        alert(`${successCount}개 항목이 성공적으로 저장되었습니다.`);
        // 원본 데이터를 현재 데이터로 업데이트
        setOriginalItems(JSON.parse(JSON.stringify(items)));
        setChangedItems(new Set()); // 변경 상태 초기화
      } else {
        alert(`${successCount}개 항목 저장 성공, ${failCount}개 항목 저장 실패`);
      }
      
    } catch (error) {
      console.error('저장 중 오류 발생:', error);
      alert('저장 중 오류가 발생했습니다.');
    }
  };

  // 공통 함수 정의
  const handleFieldChange = (index, field, newValue) => {
    console.log(`${field} onChange:`, newValue);
    
    // 1. UI 업데이트
    setItems(prev => {
      const newItems = prev.map((row, i) =>
        i === index ? {
          ...row, 
          data: {
            ...row.data,
            teachers: {
              ...row.data?.teachers,
              [field]: newValue
            }
          }
        } : row
      );
      console.log('setItems 완료:', newItems[index]);
      return newItems;
    });

    // 2. 변경된 항목으로 표시 (중복 체크)
    setChangedItems(prev => {
      if (!prev.has(index)) {
        console.log(`항목 ${index} 변경 목록에 추가`);
        return new Set([...prev, index]);
      } else {
        console.log(`항목 ${index}은 이미 변경 목록에 있음`);
        return prev;
      }
    });
  };

  const headers = [
    { 
      name: 'NO.', 
      value: '',
      renderCell: (item) => item.code
    },
    { 
      name: '고사장', 
      value: 'b_name',
      renderCell: (item) => item.name || ''
    },
    { 
      name: '총감독관수',
      value: '',
      renderCell: (item, index) => <input 
        type="number" 
        value={parseInt(item.data?.teachers?.master || 0)} 
        onChange={e => handleFieldChange(index, 'master', e.target.value)}
      />
    },
    { 
      name: '시험감독(정)', 
      value: '',
      renderCell: (item, index) => <input 
        type="number" 
        value={parseInt(item.data?.teachers?.main || 0)} 
        onChange={e => handleFieldChange(index, 'main', e.target.value)}
      />
    },
    { 
      name: '시험감독(부)', 
      value: '',
      renderCell: (item, index) => <input 
        type="number" 
        value={parseInt(item.data?.teachers?.sub || 0)} 
        onChange={e => handleFieldChange(index, 'sub', e.target.value)}
      />
    },
    { 
      name: '통제위원', 
      value: '',
      renderCell: (item, index) => <input 
        type="number" 
        value={parseInt(item.data?.teachers?.info || 0)} 
        onChange={e => handleFieldChange(index, 'info', e.target.value)}
      />
    },
    { 
      name: '관리위원', 
      value: '',
      renderCell: (item, index) => <input 
        type="number" 
        value={parseInt(item.data?.teachers?.reserve || 0)} 
        onChange={e => handleFieldChange(index, 'reserve', e.target.value)}
      />
    },
  ];
  
  useEffect(() => {
    getTestingTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log("testingObj changed:", testingObj);
    if (testingObj?.type) {
      getTestings(testingObj.type);
      setItems([]);
    } else {
      setTestings([]);
      setItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj?.type]);

  useEffect(() => {
    console.log("testingObj changed:", testingObj);
    if (testingHqs && testingHqs.length > 0 && testingObj && testingObj.testing_id) {
      getTestingPlaces();
    } else {
      setItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj?.testing_id, testingHqs]);

  return (
    <div id="testing_teacher_joins">
      <div className="head">
        <h1>회차별 감독관 설정</h1>
        <span><button onClick={handleSubmit}>저장하기</button></span>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>구분</label>
            <span>
              <select value={testingObj?.type || 0} onChange={handleTestingTypeChange}>
                <option value="">▒ 구분 ▒</option>
                {testingTypes.map((obj, index) => (
                  <option key={index} value={obj.code}>
                    {obj.nickname || obj.name}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>시험</label>
            <span>
              <select value={testingObj?.testing_id || 0} onChange={handleTestingChange}>
                <option value="">▒ 시험 ▒</option>
                {testings.map((obj, index) => (
                  <option key={index} value={obj.testing_id}>
                    {obj.title}
                  </option>
                ))}
              </select>
            </span>
          </li>
        </ul>
        <ListBody
          headers={headers}
          items={items}
          sort={sort}
          desc={desc}
          setSort={setSort}
          setDesc={setDesc}
          className="place_table"
        />
      </div>
      <div className="foot">
        <button onClick={handleSubmit}>저장하기</button>
      </div>
    </div>
  );
};

export default TestingTeacherSetup;